import styled from 'styled-components'
import { ScrollbarStyle } from '../../../styles/components/scrollbar'
import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: grid;
  grid-template-columns: 315px 1fr;

  background: ${theme.colors.secondLightGray};
`

export const Sidebar = styled.aside`
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 30px 20px 30px 25px;

  background: ${theme.colors.mainBg};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
`

export const HeaderSidebar = styled.header`
  width: 100%;
  margin-bottom: 15px;

  display: flex;
  flex-direction: column;
  gap: 10px;

  & > div {
    display: flex;
    justify-content: space-between;

    & > select {
      width: 137px;
      height: 32px;
      padding: 0 10px;

      display: flex;
      align-items: center;

      background: ${theme.colors.mainBg};
      border: 1px solid ${theme.colors.mediumGray};
      border-radius: ${theme.border.normal};
      font-family: ${theme.font.inter};
      font-weight: ${theme.font.normal};
      font-size: ${theme.font.sizes.small};
      line-height: ${theme.font.sizes.normal};
      color: ${theme.colors.darkGray};
    }
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  & > h1 {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.large};
    line-height: ${theme.font.sizes.xlarge};
    color: ${theme.colors.brown};
  }

  & > span {
    width: 24px;
    height: 24px;
    padding: 6px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 24px;
    background-color: ${theme.colors.secondLightGray};

    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xxsmall};
    line-height: ${theme.font.sizes.xsmall};
    color: ${theme.colors.brown};
  }
`

export const Search = styled.div`
  height: 35px;
  width: 100%;
  padding: 0px 10px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;
  border: 1px solid #A0A5B6;
  background: ${theme.colors.mainBg};
  overflow: hidden;

  & > svg > path,
  & > svg > circle { 
    stroke: ${theme.colors.mediumGray};
  }

  & > input {
    width: 100%;
    height: 100%;
    margin-left: 10px;

    border: none;
    font-family: ${theme.font.inter};
    font-size: ${theme.font.sizes.small};
    line-height: 125%;
    color: ${theme.colors.brown};
    
    &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      color: ${theme.colors.mediumGray};
    }
    &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: ${theme.colors.mediumGray};
      opacity:  1;
    }
    &::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: ${theme.colors.mediumGray};
      opacity:  1;
    }
    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: ${theme.colors.mediumGray};
    }
    &::-ms-input-placeholder { /* Microsoft Edge */
      color: ${theme.colors.mediumGray};
    }

    &::placeholder { /* Most modern browsers support this now. */
      color: ${theme.colors.mediumGray};
    }
  }
`

export const OrdersWrapper = styled.ul`
  width: 105%;
  height: 100%;
  padding: 0px 5px 100px 0px;

  display: flex;
  flex-direction: column;
  gap: 15px;

  overflow-x: hidden;
  overflow-y: auto;

  list-style: none;

  ${ScrollbarStyle}
`

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 35px 45px;
  overflow-x: hidden;
  overflow-y: auto;
  ${ScrollbarStyle}
`

export const NoContentWrapper = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > h4 {
    margin-top: -60px;

    font-family: ${theme.font.inter};
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.xxlarge};
    line-height: ${theme.font.sizes.huge};
    color: #000;
  }

  & > p {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.small};
    line-height: ${theme.font.sizes.normal};
    color: #000;
  }
`
